/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Типы оплаты
   */
  app.PaymentTypes = app.Collection.extend({
    
    model: app.PaymentType
    
  });
  
})();

}.call(window));